import { ContentfulImage } from '@ecomm/contentful/components'
import { Link } from '@ecomm/framework'

import type { Locale } from '@ecomm/utils'
import { includeImage } from '../../../lib/utils'
import { getPackagesMenuMiddleItems } from '../data'
import type { HeaderRedesignSchema } from '../schema'

type PackagesLinksProps = {
  readonly locale: Locale
  readonly images: HeaderRedesignSchema['images']
  readonly handleClick: (text: string) => () => void
}

export function PackagesLinks({
  locale,
  images,
  handleClick
}: PackagesLinksProps) {
  const packages = getPackagesMenuMiddleItems(locale).map(item =>
    includeImage(item, images)
  )

  return (
    <div className="flex flex-wrap gap-3 px-4 min-[1126px]:mt-2 min-[1126px]:flex-nowrap min-[1126px]:gap-6 min-[1126px]:px-0 min-[1380px]:gap-11">
      {packages.map((item, i) => (
        <Link
          className="text-neutral-black focus:outline-complementary-blue-100 flex w-full items-center border-0 border-t border-solid border-neutral-300 no-underline last-of-type:border-b last-of-type:pb-3 hover:underline focus:outline-2 focus:outline-offset-8 min-[1126px]:block min-[1126px]:w-auto min-[1126px]:rounded-md min-[1126px]:border-t-0 last-of-type:min-[1126px]:border-b-0 last-of-type:min-[1126px]:pb-0"
          key={i}
          onClick={handleClick(item.title)}
          to={item.url}
        >
          <div className="w-1/2 min-[1126px]:w-auto">
            <span className="block text-base font-bold min-[1126px]:text-sm min-[1261px]:text-base">
              {item.title}
            </span>
            <small className="mt-1 block text-xs min-[1126px]:text-[10px] min-[1261px]:text-xs">
              {item.packageName}
            </small>
          </div>
          {item.image ? (
            <div className="mb-1 mt-4 flex w-1/2 justify-center min-[1126px]:mb-auto min-[1126px]:mt-2 min-[1126px]:w-auto">
              <ContentfulImage
                className="h-[75px] w-[110px] rounded-xl md:h-[96px] md:w-[142px] min-[1126px]:mx-auto min-[1261px]:h-[117px] min-[1261px]:w-[175px]"
                {...item.image}
                quality={90}
                width={215}
              />
            </div>
          ) : null}
        </Link>
      ))}
    </div>
  )
}
